/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetProduct200ResponseAllOfData } from './GetProduct200ResponseAllOfData';
import {
    GetProduct200ResponseAllOfDataFromJSON,
    GetProduct200ResponseAllOfDataFromJSONTyped,
    GetProduct200ResponseAllOfDataToJSON,
} from './GetProduct200ResponseAllOfData';

/**
 * 
 * @export
 * @interface GetProduct200Response
 */
export interface GetProduct200Response {
    /**
     * 
     * @type {GetProduct200ResponseAllOfData}
     * @memberof GetProduct200Response
     */
    data: GetProduct200ResponseAllOfData;
    /**
     * 
     * @type {object}
     * @memberof GetProduct200Response
     */
    meta: object;
}

/**
 * Check if a given object implements the GetProduct200Response interface.
 */
export function instanceOfGetProduct200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function GetProduct200ResponseFromJSON(json: any): GetProduct200Response {
    return GetProduct200ResponseFromJSONTyped(json, false);
}

export function GetProduct200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetProduct200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': GetProduct200ResponseAllOfDataFromJSON(json['data']),
        'meta': json['meta'],
    };
}

export function GetProduct200ResponseToJSON(value?: GetProduct200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': GetProduct200ResponseAllOfDataToJSON(value.data),
        'meta': value.meta,
    };
}

